import React from 'react';

function OverviewEmptyLayoutTemplate ({ modelAttributes, helpers }) {

	const {} = modelAttributes;

	const {
		consultantPhoneNumber,
		continueShoppingUrl,
		isCustomerService,
		isLoggedIn,
		showChat,
		showSkuOnTheFly,
		signInUrl
	} = helpers;

	return (
		<>
			<div className="group" />
			{!isCustomerService && <strong className="cartEmptyWarning">Your cart is currently empty</strong>}
			{isCustomerService && <strong className="cartEmptyWarning">Cart no longer exists</strong>}
			<p className="cartEmptyText">Be sure to click the &quot;Add to Cart&quot; button on any product page.</p>
			{isCustomerService && (
				<p>
					<button type="button" data-option="import" id="emptyCartImport" className="anchorLink">
						Import Cart
					</button>
				</p>
			)}

			<div className="cartEmptyBody">
				<a href={continueShoppingUrl} className="continueShopping upperCase">
					Continue Shopping
				</a>
				{isCustomerService && <div className="addSkuContainer" id="addSkuContainerEmptyCart" />}
				{showSkuOnTheFly && (
					<div className="skuOnFlyContainer" id="skuOnFlyContainerEmptyCart">
						or
						{' '}
						<button
							type="button"
							className="anchorLink"
							data-src="/sku-on-the-fly?SkuType=Product"
							aria-haspopup="true"
						>
							Create New SKU
						</button>
					</div>
				)}
			</div>

			{!isLoggedIn && (
				<div className="needHelp">
					<div className="cartEmptySignIn">
						{'Have an Account? '}
						<a href={signInUrl}>Sign in</a>
						{' to view your cart from other logged in devices or past visits.'}
					</div>
				</div>
			)}
		</>
	);

}

export default OverviewEmptyLayoutTemplate;
